<nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
        <div class="navbar-brand">
            <img style="width: 150px;" src="assets/optima_logo.png">
        </div>
        <div>&nbsp;</div>

        <div class="collapse navbar-collapse">
            <ul class="navbar-nav ms-auto">
                <li class="nav-item">
                    <button class="btn btn-light">{{userInfo?.denominazione}}</button>
                </li>
                <li class="nav-item">
                    <a class="nav-link btn btn-outline-success" (click)="logout()">Logout</a>
                </li>
            </ul>
        </div>
    </div>
</nav>
    <!--<div class="menuIcon">
         MENU 
        <i *ngIf="!viewMenu"class="bi bi-menu-button-wide" (click)="viewMenu = !viewMenu"></i>
        <i *ngIf="viewMenu" class="bi bi-menu-button-wide-fill" (click)="viewMenu = !viewMenu"></i>
    </div>-->
    <!--<div class="logo">
         LOGO 
        <img src="assets/optima_logo.png">
    </div>-->
    <!--<div class="d-flex">

        <img src="assets/icone_varie/avatar_segnaposto_primary.svg" (click)="viewMenu = false" [routerLink]="'profile'">
        <img src="assets/icone_varie/avatar_segnaposto_red.svg" (click)="viewMenu = false" [routerLink]="'profile'">
    </div>    
</nav>-->
<!--<div class="itemSidebar" [ngStyle]="{'display': viewMenu ? 'block' : 'none'}">
    <div *ngFor="let conf of _userConfigSidebar" class="item" [ngClass]="{'active': router.url.includes('main/' + conf.url)}" (click)="viewMenu = false" [routerLink]="conf.url">
        <i *ngIf="router.url.includes('main/' + conf.url)" class="{{conf.icon_active}}"></i>
        <i *ngIf="!router.url.includes('main/' + conf.url)" class="{{conf.icon}}"></i>
        <span class="roboMenu">{{conf.label | translate}}</span>
    </div>
    <div class="item">
    <div ngbDropdown class="item d-inline-block">
        <button class="btn border-0" id="dropdownBasic1" ngbDropdownToggle>
            <img [src]="'assets/icone_varie/' + (translate.getDefaultLang() == 'it' ? 'ita' : 'eng') + '.svg'" style="margin-right: 5px;">
           <i class="bi bi-caret-down-fill"></i>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1" style="max-width: 60px;min-width: 60px;">
            <button style="color: var(--fontColor);" *ngIf="translate.getDefaultLang() != 'it'" ngbDropdownItem (click)="changeLanguage('it')"><img src="assets/icone_varie/ita.svg"></button>
            <button style="color: var(--fontColor);" *ngIf="translate.getDefaultLang() != 'en'" ngbDropdownItem (click)="changeLanguage('en')"><img src="assets/icone_varie/eng.svg"></button>
        </div>
    </div>
    </div>

</div>-->